import { Typography } from '@mui/material';
import React, { Fragment } from 'react';

const { useState, useEffect, useRef } = React;
import estilos from './FormularioDocumentacion.module.css';



const INSPECTORES = [
    { nombre: 'I.Q JOSE CARLOS FLORES ZARATE', credencial: 'C-169.22', telefono: '238 130 1031' },
    { nombre: 'BIOL. ROGELIO REYES SILVA', credencial: 'C-174.23', telefono: '443 105 1031' },
    { nombre: 'ING. GUILLERMO DONATLAN SIMENTAL', credencial: 'C-175.23', telefono: '618 117 5085' },
    { nombre: 'ING. HUGO BAUTISTA GARCIA', credencial: 'C-120.18', telefono: '951 175 5257' },
    { nombre: 'ING. RAFAEL VALDIVIA GARCES', credencial: 'C-123.18', telefono: '951 113 7260' },
    { nombre: 'ING. ROMAN G. MANCERA PACHECO/ I.Q JORGE ALEJANDRO VALENCIA MONTERO', credencial: 'C-230.25', telefono: '951 239 5191' },
    { nombre: 'I.Q EDWIN JARED KAT MARTINEZ', credencial: 'C-168.22', telefono: '971 222 2969' },
    { nombre: 'H. SAMMY HERNANDEZ PEREZ/ ING. HUGO BAUTISTA GARCIA', credencial: 'C-240.26', telefono: '951 580 0220' },
    { nombre: 'I.I CARLOS GUADALUPE RODRIGUEZ CAMACHO', credencial: 'C-204.23', telefono: '951 197 1038' },
    { nombre: 'I.I ALEXIS MARQUEZ MARTINEZ/ I.Q JORGE ALEJANDRO VALENCIA MONTERO', credencial: 'C-239.26', telefono: '951 271 2382' },
    { nombre: 'I.Q JORGE ALEJANDRO VALENCIA MONTERO', credencial: 'C-141.21', telefono: '951 343 5555' },
    { nombre: 'I.Q JOSE M. MONTENEGRO CERVANTES/ ING. HUGO BAUTISTA GARCIA', credencial: 'C-238.26', telefono: '951 234 9964' },
    { nombre: 'I.Q LUCIO MANUEL OLIVERA GARCIA', credencial: 'C-207.23', telefono: '951 283 3386' },
    { nombre: 'ING. UZIEL CRUZ BORJAS', credencial: 'C-108.16', telefono: '951 231 0883' },
];

const FormularioDocumentacion = (props) => {
    const data = props.data
    //DATOS PARA GENERAR DOCUMENTACIÓN DE CONTRATOS
    const [numeroDeCliente, setNumeroDeCliente] = useState('');
    const [datosDelActa, setdatosDelActa] = useState('');
    const [objetoSocial, setObjetoSocial] = useState('');
    const [tipoDeIdentificacion, setTipoDeIdentificacion] = useState('');
    const [otroTipoDeIdentificacion, setOtroTipoDeIdentificacion] = useState('');
    const [numeroDeIdentificacion, setNumeroDeIdentificacion] = useState('');
    const [emisionDeAcreditacion, setEmisionDeAcreditacion] = useState('');
    const [poderNotarial, setPoderNotarial] = useState('');
    const [expedidoPor, setExpedidoPor] = useState('');
    const password = data.passwordNom
    const [passwordNom, setPasswordNom] = useState('');
    const [numeroSolicitud, setNumeroSolicitud] = useState('');
    const [numCertificadoNOM, setNumCertificadoNOM] = useState('');
    const [numeroTraslado, setNumeroTraslado] = useState('');
    const [otrosServicios, setOtrosServicios] = useState('');
    const [fechaInspeccion, setFechaInspeccion] = useState('');
    const [numeroPlanEvaluacion, setNumeroPlanEvaluacion] = useState('');
    const [inspectorAsignado, setInspectorAsignado] = useState('');
    const [credencialInspector, setCredencialInspector] = useState('');
    const [telefonoInspector, setTelefonoInspector] = useState('');
    const handleInspectorChange = (nombreInspector) => {
        setInspectorAsignado(nombreInspector);
        const inspector = INSPECTORES.find(i => i.nombre === nombreInspector);
        if (inspector) {
            setCredencialInspector(inspector.credencial);
            setTelefonoInspector(inspector.telefono);
        } else {
            setCredencialInspector('');
            setTelefonoInspector('');
        }
    }


    const zeroFill = (number) => {
        let width = 4
        width -= number.length
        if (width > 0) {
            return new Array(width + (/\./.test(number) ? 2 : 1)).join('0') + number;
        }
        return number + "";
    }

    const botonAceptar = () => {
        let numCliente = numeroDeCliente
        if (numCliente.length < 5) numCliente = zeroFill(numCliente)
        if (data.regimenfiscal === 'Persona fisica') {
            const data = {
                numeroDeCliente: numCliente, tipoDeIdentificacion, numeroDeIdentificacion, otroTipoDeIdentificacion, emisionDeAcreditacion,
                numeroSolicitud, numCertificadoNOM, numeroTraslado, otrosServicios, fechaInspeccion, numeroPlanEvaluacion,
                inspectorAsignado, credencialInspector, telefonoInspector, poderNotarial
            }
            if (password) data.passwordNom = passwordNom
            props.functionAcept(data)
        } else {
            const data = {
                numeroDeCliente: numCliente, tipoDeIdentificacion, numeroDeIdentificacion, datosDelActa, objetoSocial, otroTipoDeIdentificacion, emisionDeAcreditacion,
                numeroSolicitud, numCertificadoNOM, numeroTraslado, otrosServicios, fechaInspeccion, numeroPlanEvaluacion,
                inspectorAsignado, credencialInspector, telefonoInspector, poderNotarial
            }
            if (password) data.passwordNom = passwordNom
            props.functionAcept(data)
        }
    }
    let viverista = ''
    let envasador = ''
    let productormaguey = ''
    let productormezcal = ''
    let comercializadormezcal = ''
    let comercializadorbebidasconmezcal = ''
    let cadena = ''
    if (data.viverista === true) cadena += 'Viverista'
    if (data.viverista && (data.envasador || data.productormaguey || data.productormezcal ||
        data.comercializadormezcal || data.comercializadorbebidasconmezcal)) cadena += ','

    if (data.productormaguey === true) cadena += 'Productor maguey'
    if (data.productormaguey && (data.productormezcal || data.envasador ||
        data.comercializadormezcal || data.comercializadorbebidasconmezcal)) cadena += ','

    if (data.productormezcal === true) cadena += 'Productor mezcal'
    if (data.productormezcal && (data.envasador || data.comercializadormezcal || data.comercializadorbebidasconmezcal)) cadena += ','

    if (data.envasador === true) cadena += 'Envasador'
    if (data.envasador && (data.comercializadormezcal || data.comercializadorbebidasconmezcal)) cadena += ','

    if (data.comercializadormezcal === true) cadena += 'Comercializador mezcal'
    if (data.comercializadormezcal && data.comercializadorbebidasconmezcal) cadena += ','

    if (data.comercializadorbebidasconmezcal === true) cadena += 'Comercializador de bebidas con mezcal'

    let arregloCadena = cadena.split(',')
    let combinacionCadena = ''
    let contador = 1
    for (const i in arregloCadena) {
        if (arregloCadena.length === 1) {
            combinacionCadena += arregloCadena[i]
        } else {
            if (arregloCadena.length === (contador + 1)) {
                combinacionCadena += arregloCadena[i] + ' y '
                contador++
            } else {

                combinacionCadena += arregloCadena[i]
                if (arregloCadena.length !== contador) {
                    combinacionCadena += ', '
                }
                contador++
            }

        }

    }
    return (
        <Fragment>

            <div className={`mb-3 ${estilos.divSoloBorderDocsNaranja}`}>
                <h5 className='label-dark text-center'>Información del solicitante</h5>
                <p className='label-dark'><b>Tipo de Empresa:</b> {data.regimenfiscal}<br />
                    <b>Nombre o Razón Social:</b>{data.razonsocial}<br />
                    <b>Domicilio Fiscal:</b>{data.calle}{','}{data.numerointerior}{','}{data.numeroexterior}{','}{data.colonia}{','}{data.municipio}{','}{data.localidad}{','}{data.codigopostal}{','}{data.estado}<br />
                    <b>Actividad:</b>
                    {/* {console.log("losd atos de cadena es ", data.viverista ,'?||',data.productormaguey ,'||', data.productormezcal, '||' ,data.envasador ,'||',data.comercializadormezcal ,'||',data.comercializadorbebidasconmezcal )} */}
                    {combinacionCadena} <br />
                    {
                        data.regimenfiscal !== 'Persona fisica' &&
                        <><b>Representante Legal:</b> {data.representantelegal}<br /></>
                    }
                    <b>Teléfonos:</b> {data.telefono}
                </p>
            </div>
            {
                data.regimenfiscal === 'Persona fisica' ?
                    (
                        <Fragment>
                            <div className="form-floating mb-3">
                                <input type="text" id="floatingInput" className={`form-control`}
                                    onChange={e => setNumeroDeCliente(e.target.value)}
                                    value={numeroDeCliente}
                                    placeholder='Número de Asociado' />
                                <label className="floatingInput">Número de Asociado</label>
                            </div>
                            {/* <div className='row justify-content-center'> */}
                            <div className={`form-floating mb-2 ${tipoDeIdentificacion === 'OTRO' ? 'col-md-6' : 'col-md-12'}`}>
                                {/* <select className={`form-select ${anexoMap.length > 0 ? 'inputValidado' : ''}`} */}
                                <div className="form-floating mb-3">
                                    <select className={`form-control`}
                                        value={tipoDeIdentificacion}
                                        onChange={e => setTipoDeIdentificacion(e.target.value)}
                                        id="floatingInput"
                                    >
                                        <option value="">Seleccione una opción</option>
                                        <option value={`INE`}>INE</option>
                                        <option value={`IFE`}>IFE</option>
                                        <option value={`PASAPORTE`}>PASAPORTE</option>
                                        <option value={`CÉDULA PROFESIONAL`}>CÉDULA PROFESIONAL</option>
                                        <option value={`OTRO`}>OTRO</option>
                                    </select>
                                    <label className="floatingInput">Tipo de identificación</label>
                                </div>
                            </div>
                            {
                                tipoDeIdentificacion === 'OTRO' &&
                                <div className='col-md-6'>
                                    <div className="form-floating mb-2">
                                        <input type="text" className={`form-control`}
                                            onChange={e => setOtroTipoDeIdentificacion(e.target.value)}
                                            value={otroTipoDeIdentificacion}
                                            id="" />
                                        <label className="floatingInput">Especifique</label>
                                    </div>
                                </div>
                            }
                            {/* </div> */}

                            <div className="form-floating mb-3">
                                <input type="text" id="floatingInput" className={`form-control`}
                                    onChange={e => setNumeroDeIdentificacion(e.target.value)}
                                    value={numeroDeIdentificacion}
                                    placeholder='Número de Identificación' />
                                <label className="floatingInput">Número de identificación</label>
                            </div>

                            <div className="form-floating mb-3">
                                <input type="text" id="floatingInput" className={`form-control`}
                                    onChange={e => setEmisionDeAcreditacion(e.target.value)}
                                    value={emisionDeAcreditacion}
                                    placeholder='Número de Identificación' />
                                <label className="floatingInput">Emisión de acreditación</label>
                            </div>
                            {
                                password &&
                                <div className="form-floating mb-3">
                                    <input type="text" id="floatingInput" className={`form-control`}
                                        onChange={e => setPasswordNom(e.target.value)}
                                        value={passwordNom}
                                        placeholder='Contraseña NOM' />
                                    <label className="floatingInput">Contraseña NOM</label>
                                </div>
                            }
                            {
                                data.hacerFormatos === true &&
                                <div>
                                    <hr />
                                    <h6 className='text-center'>SOLICITUD DE SERVICIOS DE INSPECCIÓN</h6>
                                    <div className='row justify-content-start mb-2 text-center'>
                                        <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                            <div className="form-floating mb-3">
                                                <input type="text" id="floatingInput" className={`form-control`}
                                                    onChange={e => setNumeroSolicitud(e.target.value)}
                                                    value={numeroSolicitud}
                                                    placeholder='No. de solicitud' />
                                                <label className="floatingInput">No. de solicitud</label>
                                            </div>
                                        </div>
                                        {/*<div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                            <div className="form-floating mb-3">
                                                <input type="text" id="floatingInput" className={`form-control`}
                                                    onChange={e => setNumCertificadoNOM(e.target.value)}
                                                    value={numCertificadoNOM}
                                                    placeholder='No. Certificado NOM vigente' />
                                                <label className="floatingInput">No. Certificado NOM vigente</label>
                                            </div>
                                        </div>
                                        <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                            <div className="form-floating mb-3">
                                                <input type="text" id="floatingInput" className={`form-control`}
                                                    onChange={e => setNumeroTraslado(e.target.value)}
                                                    value={numeroTraslado}
                                                    placeholder='Número de traslado' />
                                                <label className="floatingInput">Número de traslado</label>
                                            </div>
                                        </div>*/}
                                        <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                            <div className="form-floating mb-3">
                                                <input type="text" id="floatingInput" className={`form-control`}
                                                    onChange={e => setOtrosServicios(e.target.value)}
                                                    value={otrosServicios}
                                                    placeholder='Otros servicios' />
                                                <label className="floatingInput">Otros servicios</label>
                                            </div>
                                        </div>
                                        <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                            <div className="form-floating mb-3">
                                                <input type="text" className={`form-control`}
                                                    onChange={e => setFechaInspeccion(e.target.value)}
                                                    value={fechaInspeccion}
                                                    placeholder='Fecha de inspección' />
                                                <label className="floatingInput">Fecha de inspección</label>
                                            </div>
                                        </div>
                                    </div>
                                    <hr />
                                    <h6 className='text-center'>PLAN DE EVALUACIÓN</h6>
                                    <div className='row justify-content-start mb-2 text-center'>
                                        <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                            <div className="form-floating mb-3">
                                                <input type="text" id="floatingInput" className={`form-control`}
                                                    onChange={e => setNumeroPlanEvaluacion(e.target.value)}
                                                    value={numeroPlanEvaluacion}
                                                    placeholder='No. Plan de evaluación' />
                                                <label className="floatingInput">No. del plan de evaluación</label>
                                            </div>

                                        </div>
                                        <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                            <div className="form-floating mb-3">
                                                <select className="form-select" id="floatingSelect"
                                                    onChange={e => handleInspectorChange(e.target.value)}
                                                    value={inspectorAsignado}>
                                                    <option value="">Seleccione un inspector...</option>
                                                    {INSPECTORES.map((insp, index) => (
                                                        <option key={index} value={insp.nombre}>{insp.nombre}</option>
                                                    ))}
                                                </select>
                                                <label htmlFor="floatingSelect">Inspector asignado</label>
                                            </div>
                                        </div>
                                        <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                            <div className="form-floating mb-3">
                                                <input type="text" id="floatingInput" className={`form-control`}
                                                    onChange={e => setCredencialInspector(e.target.value)}
                                                    value={credencialInspector}
                                                    placeholder='Credencial del inspector' />
                                                <label className="floatingInput">Credencial del inspector</label>
                                            </div>
                                        </div>
                                        <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                            <div className="form-floating mb-3">
                                                <input type="text" id="floatingInput" className={`form-control`}
                                                    onChange={e => setTelefonoInspector(e.target.value)}
                                                    value={telefonoInspector}
                                                    placeholder='Teléfono del inspector' />
                                                <label className="floatingInput">Teléfono del inspector</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }

                        </Fragment>
                    ) :
                    <Fragment>

                        <div className="form-floating mb-3">
                            <input type="text" id="floatingInput" className={`form-control`}
                                onChange={e => setNumeroDeCliente(e.target.value)}
                                value={numeroDeCliente}
                                placeholder='Número de Asociado' />
                            <label className="floatingInput">Número de Asociado</label>
                        </div>

                        {/*<div className='row justify-content-center'>
                            <div className={`${tipoDeIdentificacion === 'OTRO' ? 'col-md-6' : 'col-md-12'}`}>
                                <div className="form-floating mb-3">
                                    <select className={`form-control`}
                                        value={tipoDeIdentificacion}
                                        onChange={e => setTipoDeIdentificacion(e.target.value)}
                                        id="floatingInput" >
                                        <option value="">Seleccione una opción</option>
                                        <option value={`INE`}>INE</option>
                                        <option value={`IFE`}>IFE</option>
                                        <option value={`PASAPORTE`}>PASAPORTE</option>
                                        <option value={`CÉDULA PROFESIONAL`}>CÉDULA PROFESIONAL</option>
                                        <option value={`OTRO`}>OTRO</option>
                                    </select>
                                    <label className="floatingInput">Tipo de identificación</label>
                                </div>
                            </div>
                            { tipoDeIdentificacion === 'OTRO' &&
                                <div className='col-md-6'>
                                    <div className="form-floating mb-2">
                                        <input type="text" className={`form-control`}
                                            onChange={e => setOtroTipoDeIdentificacion(e.target.value)}
                                            value={otroTipoDeIdentificacion}
                                            id="" />
                                        <label className="floatingInput">Especifique</label>
                                    </div>
                                </div>
                            }
                        </div>
                        <div className="form-floating mb-3">
                            <input type="text" id="floatingInput" className={`form-control`}
                                onChange={e => setNumeroDeIdentificacion(e.target.value)}
                                value={numeroDeIdentificacion}
                                placeholder='Número de Identificación' />
                            <label className="floatingInput">Número de identificación</label>
                        </div>
                        <div className="form-floating mb-3">
                            <input type="text" id="floatingInput" className={`form-control`}
                                onChange={e => setEmisionDeAcreditacion(e.target.value)}
                                value={emisionDeAcreditacion}
                                placeholder='Número de Identificación' />
                            <label className="floatingInput">Emisión de acreditación</label>
                        </div>*/}
                        <div className="form-floating mb-3">
                            <input type="text" id="floatingInput" className={`form-control`}
                                onChange={e => setPoderNotarial(e.target.value)}
                                value={poderNotarial}
                                placeholder='Poder Notarial' />
                            <label className="floatingInput">Poder notarial</label>
                        </div>



                        <div className="form-floating mb-3">
                            <input type="text" id="floatingInput" className={`form-control`}
                                onChange={e => setdatosDelActa(e.target.value)}
                                value={datosDelActa}
                                placeholder='Datos del Acta Constitutiva' />
                            <label className="floatingInput">Datos del Acta Constitutiva</label>

                        </div>

                        <div className="form-floating mb-3">
                            <input type="text" id="floatingInput" className={`form-control`}
                                onChange={e => setObjetoSocial(e.target.value)}
                                value={objetoSocial}
                                placeholder='Objeto Social' />
                            <label className="floatingInput">Objeto Social</label>
                        </div>

                        {
                            password &&
                            <div className="form-floating mb-3">
                                <input type="text" id="floatingInput" className={`form-control`}
                                    onChange={e => setPasswordNom(e.target.value)}
                                    value={passwordNom}
                                    placeholder='Contraseña NOM' />
                                <label className="floatingInput">Contraseña NOM</label>
                            </div>
                        }
                        {
                            data.hacerFormatos === true &&
                            <div>
                                <hr />
                                <h6 className='text-center'>SOLICITUD DE SERVICIOS DE INSPECCIÓN</h6>
                                <div className='row justify-content-start mb-2 text-center'>
                                    <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                        <div className="form-floating mb-3">
                                            <input type="text" id="floatingInput" className={`form-control`}
                                                onChange={e => setNumeroSolicitud(e.target.value)}
                                                value={numeroSolicitud}
                                                placeholder='No. de solicitud' />
                                            <label className="floatingInput">No. de solicitud</label>
                                        </div>
                                    </div>
                                    {/*<div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                        <div className="form-floating mb-3">
                                            <input type="text" id="floatingInput" className={`form-control`}
                                                onChange={e => setNumCertificadoNOM(e.target.value)}
                                                value={numCertificadoNOM}
                                                placeholder='No. Certificado NOM vigente' />
                                            <label className="floatingInput">No. Certificado NOM vigente</label>
                                        </div>
                                    </div>
                                    <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                        <div className="form-floating mb-3">
                                            <input type="text" id="floatingInput" className={`form-control`}
                                                onChange={e => setNumeroTraslado(e.target.value)}
                                                value={numeroTraslado}
                                                placeholder='Número de traslado' />
                                            <label className="floatingInput">Número de traslado</label>
                                        </div>
                                    </div>*/}
                                    <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                        <div className="form-floating mb-3">
                                            <input type="text" id="floatingInput" className={`form-control`}
                                                onChange={e => setOtrosServicios(e.target.value)}
                                                value={otrosServicios}
                                                placeholder='Otros servicios' />
                                            <label className="floatingInput">Otros servicios</label>
                                        </div>
                                    </div>
                                    <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                        <div className="form-floating mb-3">
                                            <input type="text" className={`form-control`}
                                                onChange={e => setFechaInspeccion(e.target.value)}
                                                value={fechaInspeccion}
                                                placeholder='Fecha de inspección' />
                                            <label className="floatingInput">Fecha de inspección</label>
                                        </div>
                                    </div>
                                </div>
                                <hr />
                                <h6 className='text-center'>PLAN DE EVALUACIÓN</h6>
                                <div className='row justify-content-start mb-2 text-center'>
                                    <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                        <div className="form-floating mb-3">
                                            <input type="text" id="floatingInput" className={`form-control`}
                                                onChange={e => setNumeroPlanEvaluacion(e.target.value)}
                                                value={numeroPlanEvaluacion}
                                                placeholder='No. Plan de evaluación' />
                                            <label className="floatingInput">No. del plan de evaluación</label>
                                        </div>

                                    </div>
                                    <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                        <div className="form-floating mb-3">
                                            <select className="form-select" id="floatingSelect"
                                                onChange={e => handleInspectorChange(e.target.value)}
                                                value={inspectorAsignado}>
                                                <option value="">Seleccione un inspector...</option>
                                                {INSPECTORES.map((insp, index) => (
                                                    <option key={index} value={insp.nombre}>{insp.nombre}</option>
                                                ))}
                                            </select>
                                            <label htmlFor="floatingSelect">Inspector asignado</label>
                                        </div>
                                    </div>
                                    <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                        <div className="form-floating mb-3">
                                            <input type="text" id="floatingInput" className={`form-control`}
                                                onChange={e => setCredencialInspector(e.target.value)}
                                                value={credencialInspector}
                                                placeholder='Credencial del inspector' />
                                            <label className="floatingInput">Credencial del inspector</label>
                                        </div>
                                    </div>
                                    <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                        <div className="form-floating mb-3">
                                            <input type="text" id="floatingInput" className={`form-control`}
                                                onChange={e => setTelefonoInspector(e.target.value)}
                                                value={telefonoInspector}
                                                placeholder='Teléfono del inspector' />
                                            <label className="floatingInput">Teléfono del inspector</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                    </Fragment>
            }
            <Typography id="modal-modal-description" sx={{ mt: 2 }} className='text-center'>
                Está a punto de aceptar la solicitud, ya no podrá seguir revisándola
                y los datos se tomarán como válidos.<br /> <strong>¿Desea continuar?</strong>
            </Typography>
            <div className='row'>
                <button className='btn btn-success' onClick={() => botonAceptar()}>CONTINUAR</button>
            </div>
        </Fragment>
    );
};

export default FormularioDocumentacion;
